import {pathIs} from "../utilities";
import {associations} from "./associations"
import {districts_map} from "./districts_map";

if(pathIs(['/app/association*', '/app/districts*', '/admin*'])) {
    associations()
    districts_map()
}
